import axios from 'axios'
import { Toast } from 'vant'
import errorCode from '@/utils/errorCode'
import router from '@/router'
import { getCache,clearCache } from '@/utils/cache'
import { getScopedToken, removeScopedToken, getCurrentScope } from '@/utils/authScope'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 500000
})
// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  if (!isToken) {
    const token = getScopedToken(router.currentRoute)
    if (token) {
      // 与后端约定的头部字段保持不变
      config.headers.Token = 'Bearer ' + token
    }
  }
  return config
}, error => {
  console.log(error)
  return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200
  // 获取错误信息
  const msg = errorCode[code] || res.data.msg || errorCode.default
  if (code === 401 || code === 403) {
    Toast.fail('请登录')
    // 仅清除当前系统+终端的登录态
    const currentRoute = router.currentRoute
    removeScopedToken(currentRoute)

    // 如果路由声明了登录页，则按声明跳转；否则按 scope 拼一个兜底路径或回退到通用登录
    let loginPath = currentRoute?.meta?.loginPage
    if (!loginPath) {
      const { system, terminal } = getCurrentScope(currentRoute)
      // 兜底：/{system}/{terminal}/login 或者通用 '/login'
      const fallback = `/${system}/${terminal}/login`
      loginPath = fallback || '/login'
    }
    router.replace(loginPath)
    return Promise.reject('无效的会话，或者会话已过期，请重新登录。') // eslint-disable-line

  } else if (code === 500) {
    // Toast.fail(msg)
    console.log(msg)
    Toast.fail('操作失败，请稍后重试或联系管理员')
    console.log(msg)
    return Promise.reject(new Error(msg))

  } else if (code !== 200 && code !== 60102 && code !== 60101 && code !== 60103 && code !== 60105 && code !== 60104 && code !== 80101 
    && code !== 70102 && code !== 50107 && code !== 70105 && code !== 50201 && code !== 80107 && code !== 40105 && code !== 50215
    && code !== 80106 && code !== 80102 && code !== 50217 && code !== 50204 && code !== 50211 && code !== 50212 && code !== 50216
    && code !== 50206 && code !== 50207 && code !== 50208 && code !== 50218
  ) {
    if(code === 50101 || code === 50104 || code === 50109 || code === 50103 || code === 50202 || code === 70103 
      || code === 50203 || code === 50205 || code === 50209 || code === 50210 || code === 50213 
      || code === 40102 || code === 40103 || code === 40104 || code === 40107) {
      Toast({
        message: msg,
        forbidClick: true,
        duration: 3000,
        overlay: true
      });
    }
    return Promise.reject('error') // eslint-disable-line

  } else {
    return res.data
  }
},
error => {
  console.log('err' + error)
  let { message } = error
  if (message === 'Network Error') {
    message = '后端接口连接异常'
  } else if (message.includes('timeout')) {
    message = '系统接口请求超时'
  } else if (message.includes('Request failed with status code')) {
    message = '系统接口' + message.substr(message.length - 3) + '异常'
  }
  Toast.fail(message)
  return Promise.reject(error)
}
)

export default service
